import { NSBox, NSBoxString, NSBoxTextArea, NSColumn, NSLine, NSRepeater } from "namirasoft-site-react";
import { AccessLayout } from "../AccessLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessProps } from "../AccessProps";
import { RoleFullRow, RoleInputRow, RoleRow } from "namirasoft-access";
import { AccessEntities } from "../AccessEntities";
import { useRef } from "react";
import PolicyLine from "../components/PolicyLine";

interface RoleEditPageProps extends NSARouterMakerResult, AccessProps
{
	isEdit: boolean;
}

function RoleEditPage(props: RoleEditPageProps)
{
	const NSBoxString_Name = useRef<NSBoxString>(null);
	const NSBoxTextArea_Description = useRef<NSBoxTextArea>(null);
	const NSRepeater_Policy = useRef<NSRepeater<PolicyLine, string>>(null);

	return (
		<AccessLayout<RoleRow, RoleInputRow> {...props}
			action={{
				title: "",
				description: "Create new roles customized to your organizational structure, defining specific permission policies to simplify account management.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.role(props),
				edit: {
					...props,
					ui: {
						tab_page_edit: {
							editor: {
								getInputRow: () =>
								{
									let name = NSBoxString_Name.current?.getValue() ?? "";
									let description = NSBoxTextArea_Description.current?.getValue() ?? "";
									let policies: (string | null)[] = NSRepeater_Policy.current?.getValue() ?? [];
									return { name, description, policies, role_category: [], role_field: [], role_tag: [] }
								},
								setRow: (row) =>
								{
									let e = row as RoleFullRow;
									let policies = e.policies.filter((item): item is string => item !== null);
									NSBoxString_Name.current?.setValue(e.name);
									NSBoxTextArea_Description.current?.setValue(e.description ?? "");
									NSRepeater_Policy.current?.setValue(policies);
								}
							}
						}
					}
				}
			}}>
			<NSColumn>
				<NSBoxString
					ref={NSBoxString_Name}
					required
					title="Name"
					style={{ width: NSBox.width.double }}
					info={{link: "https://namirasoft.com/access/console-guide/role/#field-name"}}
				/>
				<NSBoxTextArea
					ref={NSBoxTextArea_Description}
					required={false}
					title="Description"
					rows={5}
					style={{ width: NSBox.width.double }}
					info={{link: "https://namirasoft.com/access/console-guide/role/#field-description"}}
				/>
				<NSLine />
				<NSRepeater<PolicyLine, string>
					ref={NSRepeater_Policy}
					title="Policies"
					required
					createItem={(gIndex: number, lIndex: number, ref: React.RefObject<PolicyLine>, onChange: () => void, onDelete: undefined | ((index: number) => void)) =>
					{
						return <PolicyLine
							ref={ref}
							{...props}
							key={`RoleEditPage_NSRepeater_PolicyLine_key_${gIndex}`}
							index={lIndex}
							deletable={true}
							onChanged={() =>
							{
								onChange();
							}}
							onDelete={() =>
							{
								onDelete?.(lIndex);
							}}
							servers={props.servers}
						/>;
					}}
					isEmpty={function (_, value: string | null): boolean
					{
						return !PolicyLine.IS_DIRTY(value);
					}}
					getValue={function (item: PolicyLine, checkError: boolean): string
					{
						return item.getValue(checkError);
					}}
					setValue={function (item: PolicyLine, _: number, value: string | null): void
					{
						if (value)
							item.setValue(value);
					}}
					style={{ width: "100%" }}
					info={{link: "https://namirasoft.com/access/console-guide/role/#field-policies"}}
				/>
			</NSColumn>
		</AccessLayout>
	);
}

export default RoleEditPage;